import {
  Appointment,
  APPOINTMENT_CHANNEL,
  APPOINTMENT_STATUS,
  TYPES_OF_APT,
} from "@elixir/types";
import {
  createAppointment,
  getMe,
  sendAppointmentCommunication,
  updateAppointment,
} from "../../utils/bridges/methods";
import { ControllerReturnType } from "../types";
import generateAppointmentId from "./generate-appointment-id";
import dayjs from "dayjs";
import { convertDateToFirestoreTimestamp } from "../../firestore/utils";
import { MESSAGE_TYPE } from "../../utils/bridges/events/types";
import {
  trackAppointmentActivity,
  AptActivityType,
} from "./appointment-activity";

export default async function addFollowupDateToApt({
  appointment,
  follow_up,
}: {
  appointment: Pick<
    Appointment,
    "doctor_oid" | "aid" | "clinic_id" | "follow_up" | "patient" | "business_id"
  >;
  follow_up: Date;
}): Promise<ControllerReturnType> {
  try {
    const { aid } = appointment;
    await updateAppointment({
      aid,
      data: { follow_up: convertDateToFirestoreTimestamp(follow_up) },
    });
    trackAppointmentActivity({
      aid,
      activity: AptActivityType.FOLLOWUP_DATE_ADDED,
    });

    performFollowupActions({ appointment: { ...appointment, follow_up } });
    return { success: true };
  } catch (e) {
    console.error(e);
    return { success: false };
  }
}

export async function performFollowupActions({
  appointment,
}: {
  appointment: Pick<
    Appointment,
    "doctor_oid" | "aid" | "clinic_id" | "follow_up" | "business_id"
  > & { patient: Pick<Appointment["patient"], "oid" | "uuid"> };
}) {
  if (!appointment.follow_up) {
    return;
  }

  const myProfile = getMe();
  const aid = generateAppointmentId();
  const { follow_up, clinic_id, doctor_oid, patient } = appointment;

  const followUpDate = new Date(follow_up);
  const aptTimeStamp = convertDateToFirestoreTimestamp(followUpDate);

  const expiry = convertDateToFirestoreTimestamp(
    dayjs(followUpDate).add(1, "year").toDate()
  );

  await createAppointment({
    aid,
    data: {
      full_date: aptTimeStamp,
      date: aptTimeStamp,
      start_time: aptTimeStamp,
      end_time: aptTimeStamp,
      doctor_oid,
      aid,
      patient_oid: patient.oid,
      patient_uuid: patient.uuid,
      clinic_id,
      channel: APPOINTMENT_CHANNEL.FOLLOW_UP,
      status: APPOINTMENT_STATUS.INITIATED,
      visit_type: TYPES_OF_APT.FOLLOW_UP,
      archive: false,
      bid: myProfile.business.id,
      tags: [],
      receipts: [],
      comm_meta: [],
      vc_meta: null,
      apt_fields: [],
      expires_at: expiry,
      p_aid: appointment.aid,
    },
  });

  trackAppointmentActivity({
    aid,
    activity: AptActivityType.CREATED,
  });

  sendAppointmentCommunication({
    aid,
    data: { msg_type: MESSAGE_TYPE.SCHEDULE_FOLLOWUP_REMINDER },
  });
}
